import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["row", "caret"];
  static values = { open: { type: Boolean, default: false } };

  openValueChanged() {
    this.rowTargets.forEach((row) => row.classList.toggle("hidden", !this.openValue));
    this.caretTarget.classList.toggle("rotate-180", !this.openValue);
  }

  toggle() {
    this.openValue = !this.openValue;
  }
}
